import { snap, units } from '@m/alchemy-ui/theme';
import styled from 'styled-components';
import { GridCol as AlchemyCol } from '@m/alchemy-ui/GridCol';
import { Grid as AlchemyGrid } from '@m/alchemy-ui/Grid';
import { Pagination as AlchemyPagination } from '@m/alchemy-ui/Pagination';
import { GridRow as AlchemyRow } from '@m/alchemy-ui/GridRow';
import { Table as AlchemyTable } from '@m/alchemy-ui/Table';

export const Grid = styled(AlchemyGrid)`
  margin-left: ${snap(25)};
`;

export const GridHeader = styled(AlchemyRow)`
  margin-top: ${units(3)};
  margin-bottom: ${units(1.5)};
`;

export const GridRow = styled(AlchemyRow)`
  margin-top: ${snap(10)};
  margin-bottom: ${snap(15)};
`;

export const ChartActionsRow = styled(AlchemyRow)`
  margin-top: ${snap(4)};
  margin-bottom: ${snap(4)};
  align-items: center;
  justify-content: flex-end;
`;

export const ScoreCardsRow = styled(GridRow)<{ $compact?: boolean }>`
  ${({ $compact }) =>
    $compact
      ? `
        column-gap: 16px;
        row-gap: 16px;
        justify-content: flex-start;
      `
      : ''}
`;

export const ChartScroll = styled.div<{ width?: number }>`
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  max-width: 100%;
  overflow-x: auto;
`;

export const ChartScrollInner = styled.div<{ minWidth: number }>`
  min-width: ${({ minWidth }) => minWidth}px;
`;

export const GridCol = styled(AlchemyCol)`
  padding-left: ${snap(4)} !important;
  padding-right: ${snap(4)} !important;
`;

export const ScoreCardItem = styled.div`
  flex: 0 0 auto;
`;

export const Pagination = styled(AlchemyPagination)`
  margin-left: auto;
  margin-right: auto;
  margin-top: ${units(1)};
`;

export const Table = styled(AlchemyTable)`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`;
